import { render, staticRenderFns } from "./SummaryKid.vue?vue&type=template&id=c40d0942"
import script from "./SummaryKid.vue?vue&type=script&lang=js"
export * from "./SummaryKid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports